import api from "@/api/axios";
import { ApiResponse } from "@/types/apiResponse";
import { SubscriptionPrice, Subscription } from "@/types/subscription";
import { PremiumCalculator } from "@/types/premiumTypes";

export async function fetchSubscriptionPrices() {
  const res = await api.get<
    ApiResponse<Record<PremiumCalculator, SubscriptionPrice[]>>
  >("/stripe/prices");

  return res.data.data;
}

export async function fetchStripeUrl(subscriptionPrice: SubscriptionPrice) {
  const res = await api.post("/stripe/create-checkout-session", {
    price_id: subscriptionPrice.priceId,
    calculator: subscriptionPrice.calculator,
  });

  return res.data.url;
}

export async function fetchStripeDestinyMatrixProductUrl(
  purchasedDate: string
) {
  const res = await api.post("/stripe/product-matrix-session", {
    matrix_date: purchasedDate,
  });

  return res.data.url;
}

export async function fetchStripeSuccess(sessionId: string) {
  const res = await api.get<ApiResponse<Subscription[]>>("/stripe/success", {
    params: { session_id: sessionId },
  });

  return res.data.data;
}

export async function fetchCancelSubscription(id: number) {
  const res = await api.post<ApiResponse<Subscription[]>>(
    `/stripe/cancel/${id}`
  );

  return res.data.data;
}
